import { FC } from 'react';

import WaveUIProgressDialog from '@/shared/components/dialogs/WaveUIProgressDialog';
import WaveUINotificationBar from '@/shared/components/utilities/WaveUINotificationBar';
import useModalDialog from '@/shared/hooks/useModalDialog';
import useNotificationBar from '@/shared/hooks/useNotificationBar';
import useProgressDialog from '@/shared/hooks/useProgressDialog';
import DialogName from '@/shared/types/dialogName.enum';
import Provider from '@/shared/types/fulfilment/provider.type';

import AddFulfilmentProviderFormDialog from './components/AddFulfilmentProviderFormDialog';
import FulfilmentProvidersTable_v2 from './components/FulfilmentProvidersTable_v2/FulfilmentProvidersTable_v2';
import useFulfilmentProvidersOperations from './hooks/useFulfilmentProvidersOperations';

const FulfilmentProviders: FC = () => {
  const { progressDialog, onUpdateProgressDialog } = useProgressDialog();
  const { notificationBar, onUpdateNotificationBar } = useNotificationBar();
  const { dialog, onUpdateDialogState } = useModalDialog<
    Provider,
    DialogName
  >();

  const {
    supportedProviders,
    refreshTableIndex,
    handleAddNewProvider,
    handleUpdateProvider,
    onOpenUpdateProviderDialog,
  } = useFulfilmentProvidersOperations({
    onUpdateDialogState,
    onUpdateNotificationBar,
    onUpdateProgressDialog,
  });

  return (
    <>
      <FulfilmentProvidersTable_v2
        refreshTableIndex={refreshTableIndex}
        onOpenUpdateProviderDialog={(provider) => {
          void onOpenUpdateProviderDialog(provider);
        }}
        onOpenAddProviderDialog={() => {
          onUpdateDialogState(DialogName.UpdateProvider, {
            open: true,
            errors: [],
            data: undefined,
          });
        }}
      />

      {dialog?.updateProvider?.open && (
        <AddFulfilmentProviderFormDialog
          supportedProviders={supportedProviders}
          initialProvider={dialog.updateProvider?.data || null}
          onClose={() =>
            onUpdateDialogState(DialogName.UpdateProvider, { open: false })
          }
          getFormValues={(formValues, providerId) => {
            if (providerId) {
              void handleUpdateProvider(providerId, formValues);
            } else {
              void handleAddNewProvider(formValues);
            }
          }}
        />
      )}

      <WaveUINotificationBar
        message={notificationBar.message}
        severity={notificationBar.severity}
        open={notificationBar.open}
        close={() => onUpdateNotificationBar({ open: false })}
      />

      <WaveUIProgressDialog
        title={progressDialog.title}
        progress={progressDialog.progress}
        open={progressDialog.open}
      />
    </>
  );
};

export default FulfilmentProviders;
